module.exports = __webpack_public_path__ + "img/share.ce2092c7.png";